import { defaultLang } from '@/i18n';
import { LangStoreType } from '@/types/store/lang-store.type';

export const state: LangStoreType = {
  lang: defaultLang,
};
